<template>
  <layout>
    <rdkm-title>
      {{ $t('Справочник NMDP') }}
    </rdkm-title>
    <div class="tile">
      <filter-form :hlaType="query.hlaType"
                   :sourceG="query.sourceG"
                   :dest="query.dest"
                   v-on:search="$refs.grid.filter($event, true)"></filter-form> 
      <rdkm-grid ref="grid" :state="query">
        <grid-column width="150" name="code" :title="$t('Код')"></grid-column>
        <grid-column width="270" name="g1" :title="$t('Значение в группе G1')"></grid-column>
        <grid-column width="270" name="g2" :title="$t('Значение в группе G2')"></grid-column>
        <grid-column name="hla" :title="$t('Аллели')"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import FilterForm from './Filter.vue';
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";
import ImportModal from '@/pages/groupGCodes/ImportModal';

export default {
  name: "Mac",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn,
    "filter-form": FilterForm,
    'import-modal': ImportModal,
  }
};
</script>
